import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  flatshowLink: {
    position: 'fixed',
    bottom: '10px',
    left: '30px',
    display: 'flex',
    zIndex: '99',
    [theme.breakpoints.down('md')]: {
      left: '10px',
    },
  },
  flatshowLogo: {
    width: '32px',
    height: '34px',
  },
}));
